import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { installationsCampaignsState } from '../../storage/Installations';
import { getCampaignList } from '../../services/installationService';

function CampaignProvider() {
  const setCampaigns = useSetRecoilState(installationsCampaignsState);

  useEffect(() => {
    const loadCampaigns = async () => {
      const { campaigns } = await getCampaignList();
      if (campaigns) setCampaigns(campaigns);
      else setCampaigns(undefined);
    };
    loadCampaigns();
  }, []);

  return null;
}

export default CampaignProvider;
